"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Cell_1 = require("./Cell");
var Container_1 = require("./Container");
var LayoutGrid = (function (_super) {
    __extends(LayoutGrid, _super);
    function LayoutGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutGrid.Cell = Cell_1.default;
    return LayoutGrid;
}(Container_1.default));
exports.default = LayoutGrid;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/layout-grid/lib/index.js
// module id = ./node_modules/@react-mdc/layout-grid/lib/index.js
// module chunks = 1 2